import Phaser from 'phaser';

export function drawDigitalCityBackdrop(scene: Phaser.Scene, animated = false): void {
  scene.cameras.main.setBackgroundColor('#06152f');
  const graphics = scene.add.graphics();
  graphics.fillGradientStyle(0x020916, 0x06152f, 0x0b2752, 0x06152f, 1);
  graphics.fillRect(0, 0, 1600, 900);

  graphics.lineStyle(2, 0x168cff, 0.1);
  for (let y = 110; y < 900; y += 92) graphics.lineBetween(0, y, 1600, y);
  for (let x = 55; x < 1600; x += 100) graphics.lineBetween(x, 0, x, 900);

  const buildings: Array<[number, number, number, number]> = [
    [32, 560, 150, 340], [196, 640, 110, 260], [320, 495, 190, 405], [524, 610, 120, 290],
    [662, 535, 176, 365], [852, 650, 118, 250], [988, 500, 180, 400], [1182, 580, 118, 320],
    [1314, 450, 236, 450],
  ];
  buildings.forEach(([x, y, width, height], buildingIndex) => {
    graphics.fillStyle(buildingIndex % 2 ? 0x071b3b : 0x0a2147, 0.96).fillRoundedRect(x, y, width, height, 10);
    graphics.lineStyle(2, buildingIndex === buildings.length - 1 ? 0xff8a34 : 0x168cff, 0.32).strokeRoundedRect(x, y, width, height, 10);
    for (let windowY = y + 28; windowY < y + height - 20; windowY += 38) {
      for (let windowX = x + 22; windowX < x + width - 15; windowX += 38) {
        const lit = (windowX + windowY + buildingIndex) % 4 !== 0;
        graphics.fillStyle(lit ? 0x1ed8ff : 0x123766, lit ? 0.26 : 0.14).fillRoundedRect(windowX, windowY, 13, 8, 2);
      }
    }
  });

  const lines = scene.add.graphics().setDepth(1);
  lines.lineStyle(6, 0x168cff, 0.22);
  const routes: Array<[number, number, number, number]> = [[40, 710, 390, 590], [390, 590, 730, 710], [730, 710, 1050, 555], [1050, 555, 1540, 680]];
  routes.forEach(([x1, y1, x2, y2]) => lines.lineBetween(x1, y1, x2, y2));
  if (animated) {
    [0, 1, 2, 3].forEach((index) => {
      const pulse = scene.add.circle(120 + index * 365, 700 - (index % 2) * 80, 6, index === 3 ? 0xff8a34 : 0x1ed8ff, 0.95).setDepth(2);
      scene.tweens.add({ targets: pulse, alpha: 0.2, scale: 1.8, duration: 700 + index * 120, yoyo: true, repeat: -1 });
    });
  }
  graphics.fillStyle(0x1ed8ff, 0.08).fillCircle(230, 290, 340);
  graphics.fillStyle(0xff8a34, 0.07).fillCircle(1380, 180, 300);
}

export const drawCircuitBackdrop = drawDigitalCityBackdrop;

export function addBrand(scene: Phaser.Scene, y = 830): void {
  if (scene.textures.exists('turncom360-wordmark')) {
    scene.add.rectangle(800, y, 250, 56, 0xffffff, 0.92).setStrokeStyle(2, 0xff8a34, 0.55).setDepth(9);
    scene.add.image(800, y, 'turncom360-wordmark').setDisplaySize(218, 47).setOrigin(0.5).setDepth(10);
  }
  scene.add.text(800, y + 36, 'WE CONNECT IT.  WE TEACH IT.  WE BUILD THE FUTURE.', {
    fontFamily: 'Arial, sans-serif', fontSize: '13px', color: '#ffffff', letterSpacing: 2,
  }).setOrigin(0.5).setAlpha(0.78).setDepth(10);
}
